<template>
  <section class="home-testimonial pt-2">
    <carousel v-bind:perPageCustom="[[320, 1], [768, 2], [991, 3]]" v-bind:navigationEnabled="true"
      v-bind:scrollPerPage="false">
      <slide>
        <div><a href="https://www.oddvega.com/media/details/ea9f1fd3-831d-45e9-81c3-01a3901e4851"><img
              src="@/assets/images/media_slide1.jpg" alt=""></a></div>
      </slide>
      <slide>
        <div><a href="https://www.oddvega.com/media/details/46b85708-9c8d-4e57-bc4e-ba37583c0172"><img
              src="@/assets/images/media_slide.jpg" alt=""></a></div>
      </slide>
      <slide>
        <div><a href="https://www.oddvega.com/media/details/2cce2d9d-6f42-431f-be38-41933bdd4a8d"><img
              src="@/assets/images/a-universe-of-endless-possibilities.jpg" alt=""></a></div>
      </slide>
      <slide>
        <div><a href="https://www.oddvega.com/media/details/553cacbe-821c-409b-bd0d-690990738ebb"><img
              src="@/assets/images/welcome-to-carr-challenge.jpg" alt=""></a></div>
      </slide>
      <slide>
        <div><a href="https://www.oddvega.com/media/details/5f96be56-aa82-4e3a-995e-07d945c5c7e6"><img
              src="@/assets/images/sholom-benzev-wins-carr-challenge-snap-quiz-new.jpg" alt=""></a></div>
      </slide>
      <slide>
        <div><a href="https://www.oddvega.com/media/details/9c5b12fc-be9a-452e-9d9a-522081bfbbba"><img
              src="@/assets/images/shaping-the-future-of-education.jpg" alt=""></a></div>
      </slide>
      <slide>
        <div><a href="https://www.oddvega.com/media/details/892c57bf-0c26-421b-ae02-8bb4fe5b2ddb"><img
              src="@/assets/images/peter-carr-talks-about-risk-lattes-global-quiz-competition.jpg" alt=""></a></div>
      </slide>
    </carousel>
  </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'home-media',
  props: [],
  components: {
    Carousel,
    Slide
  },
  mounted() {

  },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        dots:false
      },
    }
  },
  methods: {
    next() {
      this.$refs.slick.next()
    },
    prev() {
      this.$refs.slick.prev()
    },
    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick()
    }
  },
  computed: {

  }
}
</script>

<style lang="scss">
.home-testimonial {
  margin: 0 -5px;
}
.VueCarousel-slide > div {
        padding: 10px;
        text-align: left;
        background: rgba(24, 24, 24, 0.7);
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
        border: 1px solid #2c2b2b;
        border-radius: 5px;
}
.VueCarousel-pagination{display:none !important;}
.VueCarousel-navigation-button {
    color: #ffc107 !important;
    opacity: 1 !important;
    width: 30px;
    line-height: 1;
    &:before{
      opacity: 1 !important;
      font-size: 20px !important;
      top: 0 !important;
    }
    &:hover{background:#ffc107 !important;color: #000000 !important;}
}
</style>
